module.exports = __webpack_public_path__ + "static/irishOpenStringPlucked-3f1bfcd9fe9723ad2a979621042f22b6.mp3";